;(async () => {
  if (customElements.get('product-card-selector')) {
    return
  }

  const storeModuleURL = window.__GLOBAL__.assets.store
  const module = await import(storeModuleURL)
  const store = module.default

  class ProductCardSelector extends HTMLElement {
    constructor() {
      super()

      // Settings
      this.selectors = {
        form: '[data-options-form]',
        options: '[data-option]',
        values: '[data-value]',
        select: '[data-options]',
        selectOption: '[data-options-option]',
        submit: '[data-submit]',
        idInput: '[name="id"]',
      }
      this.optionSelector = ''
    }

    connectedCallback() {
      // Elements
      this.form = this.querySelector(this.selectors.form)
      this.options = this.querySelectorAll(this.selectors.options)
      this.values = this.querySelectorAll(this.selectors.values)
      this.select = this.querySelector(this.selectors.select)
      this.submit = this.querySelector(this.selectors.submit)

      // Handlers
      this.onSubmitFormHandler = this.onSubmitForm.bind(this)
      this.onChangeOptionHandler = this.onChangeOption.bind(this)

      // Listeners
      this.form.addEventListener('submit', this.onSubmitFormHandler)
      this.values.forEach((value) => {
        value.addEventListener('change', this.onChangeOptionHandler)
      })

    }

    onChangeOption(event) {
      const optionPosition = /collections/.test(document.location)
        ? 2 // This is just a temporary fix (SearchSpring needs to update implementation)
        : event.target.dataset.optionIndex
      const optionValue = event.target.value

      this.generateOptionSelector(optionValue, optionPosition)
    }

    clearSelectedOption(optionPosition) {
      const option = this.querySelector(
        `${this.selectors.options}[data-option-index="${optionPosition}"]`
      )

      this.resetOptionValuesCheck(option)
    }

    generateOptionSelector(optionValue, optionPosition) {
      this.optionSelector += `${this.selectors.selectOption}[data-option${optionPosition}="${optionValue}"]`

      if (this.options.length === 1) {
        this.changeSelectOption()
        this.clearSelectedOption(optionPosition)
        typeof this.form.requestSubmit !== 'undefined'
          ? this.form.requestSubmit(this.submit)
          : this.form.dispatchEvent(new Event('submit'))

        return
      }

      this.changeSelectOption()
      this.showNextOption(optionPosition)
    }

    showNextOption(currentOptionPosition) {
      const nextOption = this.options[currentOptionPosition]

      if (!nextOption) {
        typeof this.form.requestSubmit !== 'undefined'
          ? this.form.requestSubmit(this.submit)
          : this.form.dispatchEvent(new Event('submit'))

        return
      }

      nextOption.classList.remove('hidden')

      this.options.forEach((option) => {
        if (option === nextOption) {
          return
        }

        option.classList.add('hidden')
      })
    }

    changeSelectOption() {
      this.select.value = this.select.querySelector(this.optionSelector).value
    }

    onSubmitForm(event) {
      event.preventDefault()

      if (this?.select?.selectedOptions[0].disabled) {
        this.disableSubmitButton()
        this.resetOptionSelector()
        this.resetOptionsState()

        return
      }

      const id = this.querySelector(this.selectors.idInput).value

      store.dispatch('addItems', {
        [id]: 1,
      }, true)

      this.resetOptionSelector()
      this.resetOptionsState()
    }

    disableSubmitButton() {
      this.submit.textContent = this.submit.dataset.soldText

      // Restore button state after 2 seconds
      setTimeout(() => {
        this.submit.textContent = this.submit.dataset.addText
      }, 2000)
    }

    resetOptionValuesCheck(option) {
      if (!option) {
        return
      }
      option.querySelectorAll(this.selectors.values).forEach((value) => {
        value.checked = false
      })
    }

    resetOptionSelector() {
      this.optionSelector = ''
    }

    resetOptionsState() {
      this.options.forEach((option, index) => {
        if (index === 0) {
          option.classList.remove('hidden')

          this.resetOptionValuesCheck(option)

          return
        }

        this.resetOptionValuesCheck(option)

        option.classList.add('hidden')
      })

      this.resetOptionSelector()
    }
  }

  customElements.define('product-card-selector', ProductCardSelector)
})()
